module.exports = __webpack_public_path__ + "static/desktopHero-09ed68b08a1aba1ea326b857aae4f0a9.png";